module.exports = __webpack_public_path__ + "img/Icon-Immunizations.c91b3974.svg";